// extracted by mini-css-extract-plugin
export default {"inputWithType":"InputWithTypeField__inputWithType--Vlqxg"};